import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-add-auction',
  templateUrl: './add-auction.component.html',
  styleUrls: ['./add-auction.component.css'],
})
export class AddAuctionComponent implements OnInit {
  // one step back
  returnUrl: string = '../';
  // initial step number
  stepActive = 1;
  auctionId: number;
  auctionCode: string;
  editMode: boolean;
  showSteps = false;
  auctionStatus: number;
  statusString = '';
  websiteUrl: string = environment.websiteUrl;

  needSteps: boolean = true;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnInit() {
    this.route.params.subscribe((param) => {
      if (+param['id'] > 0) {
        this.auctionId = +param['id'];
        this.statusString = 'updated';
        this.editMode = true;
        this.returnUrl = '../../';
      } else {
        this.editMode = false;
        this.statusString = 'created';
        this.auctionId = 0;
      }
    });
  }

  openLink(url) {
    window.open(url, '_blank');
  }

  openLotsLink(url) {
    window.open(url + '#check', '_blank');
  }

  gotoAuctionListing() {
    if (this.auctionStatus == 1) {
      this.router.navigate([this.returnUrl], {
        relativeTo: this.route,
        queryParams: { type: 'live' },
      });
    } else if (this.auctionStatus == 2) {
      this.router.navigate([this.returnUrl], {
        relativeTo: this.route,
        queryParams: { type: 'upcoming' },
      });
    } else if (this.auctionStatus == 4) {
      this.router.navigate([this.returnUrl], {
        relativeTo: this.route,
        queryParams: { type: 'recent' },
      });
    } else {
      this.router.navigate([this.returnUrl], {
        relativeTo: this.route,
        queryParams: { type: 'pending' },
      });
    }
  }

  setActiveStep(step: number) {
    this.stepActive = step;
  }

  setNewAuctionId(newId: number) {
    this.auctionId = newId;
  }

  setNewAuctionCode(code: string) {
    this.auctionCode = code;
  }

  getAuctionStatus(event) {
    this.auctionStatus = event;
  }

  goToCurrentStep(step) {
    if (this.auctionStatus !== 3 && this.auctionId) {
      this.stepActive = step;
    }
  }

  copyText(val: string) {
    let selBox = this.document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    this.document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    this.document.execCommand('copy');
    this.document.body.removeChild(selBox);
  }
}
